import React, { Component } from 'react'
import styles from './styles.scss'

import { TimelineMax, TweenMax, Power3, Expo } from 'gsap'

import Cover from 'src/components/cover-img'

import raf from 'src/utils/raf'
import resize from 'src/utils/resize'
import values from 'src/values'
import config from 'src/config'
import components from 'src/utils/components'

export default class Triangle extends Component {
  constructor(props) {
    super(props)

    this.key = `${this.props.type}-${Math.random()}`
  }

  componentDidMount() {
    this.initTL()
    this.onResize()

    raf.add(this.onRAF)
    resize.add(this.onResize, this.key)
  }

  componentWillUnMount() {
    raf.remove(this.raf)
    resize.remove(this.onResize, this.key)
  }

  initTL() {
    this.tlRAF = new TimelineMax({
      paused: true
    })

    this.tlRAF
      .fromTo(
        this.refs.content,
        1,
        {
          x: 500
        },
        {
          x: -100
        },
        0
      )
      .fromTo(
        this.refs.blockImgContainer,
        1,
        {
          x: 300
        },
        {
          x: -100
        },
        0
      )
      .fromTo(
        this.refs.blockTopImgContainer,
        1,
        {
          x: 100
        },
        {
          x: -50
        },
        0
      )
  }

  onResize = () => {
    if (!this.refs.component) return

    const $component = this.refs.component.getBoundingClientRect()

    this.topComponent = $component.top + values.scroll.currentY
    this.yOffset =
      this.topComponent < values.viewport.height
        ? this.topComponent
        : this.topComponent - values.viewport.height

    this.leftComponent = $component.left
    this.xOffset =
      this.leftComponent < values.viewport.width
        ? this.leftComponent
        : this.leftComponent - values.viewport.width

    this.hComponent = this.refs.component.offsetHeight
    this.wComponent = this.refs.component.offsetWidth

    this.wBlockImgContainer = this.refs.blockImgContainer.offsetWidth
    TweenMax.set(this.refs.blockImgContainer, {
      height: this.wBlockImgContainer * 0.7
    })

    this.wBlockTopImgContainer = this.refs.blockTopImgContainer.offsetWidth
    TweenMax.set(this.refs.blockTopImgContainer, {
      height: this.wBlockTopImgContainer * 0.7
    })

    if (this.props.isCover) {
      TweenMax.set(this.refs.coverBg, {
        height: '100%',
        width: 'auto'
      })

      const w =
        values.viewport.height / this.props.coverSize.h * this.props.coverSize.w

      const x =
        w > values.viewport.width ? w - this.wComponent : -this.wComponent + w

      TweenMax.set(this.refs.coverBg, {
        x: x * this.props.item
      })
    }

    this.viewportDivisor = this.props.specificModule
      ? this.wComponent
      : this.wComponent + values.viewport.width
  }

  onRAF = () => {
    if (!this.refs.component || values.viewport.width < config.bp.md) return

    this.perc = (values.scroll.currentX - this.xOffset) / this.viewportDivisor

    if (this.tlRAF && this.perc >= 0) this.tlRAF.progress(this.perc)
  }

  render() {
    return (
      <div ref="component" className="component triangle">
        <div className="wrapper-content">
          <div className="grid-16 grid-wrapper">
            <div ref="blockTopImgContainer" className="block-top-img-container">
              <div ref="overflowCoverTop" className="overflow-cover">
                <Cover
                  ref="cover"
                  src={`${process.env.PUBLIC_URL}/img/${
                    this.props.desktop.topImg
                  }`}
                />
              </div>
            </div>
            <div ref="blockImgContainer" className="block-img-container">
              <div ref="overflowCover" className="overflow-cover">
                <Cover
                  ref="cover"
                  src={`${process.env.PUBLIC_URL}/img/${
                    this.props.desktop.btmImg
                  }`}
                />
              </div>
            </div>
            <div ref="content" className="content">
              <p dangerouslySetInnerHTML={{ __html: this.props.content }} />
            </div>
          </div>
        </div>
        {(this.props.desktop || this.props.cover) && (
          <img
            ref="coverBg"
            className="cover-bg"
            src={`${process.env.PUBLIC_URL}/img/${
              this.props.desktop ? this.props.desktop.cover : this.props.cover
            }`}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/World/desktop/triangle/index.js